$(function customFooter() {
    // 添加自定义图片
    $(".sf__footer-bottom").before('<div id="footer-custom-img" class="footer-custom-img mt-7 lg:mt-8 xl:mt-0"><img class="hidden md:block w-full" src="https://cdn.shopifycdn.net/s/files/1/0270/4592/0812/files/footer-bg-top.png?v=1669021048"><img class="md:hidden w-full" src="https://cdn.shopifycdn.net/s/files/1/0270/4592/0812/files/footer-bg-top-m.png?v=1669020735"></div>');

    var footerBottom = document.getElementsByClassName('sf__footer-bottom')[0];
    var footerBottomInner = document.getElementsByClassName('sf__footer-bottom-inner')[0];
    var footerLeft = document.getElementsByClassName('sf-footer__left')[0];
    var footerRight = document.getElementsByClassName('sf-footer__right')[0];
    var footerLinks = document.getElementsByClassName('social-media-links')[0];
    footerBottom.classList.add('pt-7','lg:pt-0');
    footerBottom.classList.remove('mt-5','md:mt-0'); 
    footerBottomInner.classList.add('lg:py-8');
    footerBottomInner.classList.remove('lg:py-5','lg:pb-8');
    footerLeft.classList.add('md:w-auto');
    footerLeft.classList.remove('lg:w-auto');
    footerRight.classList.add('md:w-auto');
    footerRight.classList.remove('lg:w-auto');
    footerLinks.classList.add('mb-1','px-9');
    footerLinks.classList.remove('ml-3','mb-6','px-2');
});